import {PayloadAction} from "../payload-action.interface";
import {AuditEntity} from "./audit.entity";
import {AuditActions} from "./audit.actions";


export function AuditReducer(state: Array<AuditEntity> = [], action: PayloadAction) {
  let newState;

  switch (action.type) {
    case AuditActions.REMOVE:
      return state.filter((contact) => contact._id !== action.payload);
    case AuditActions.ADD:
    case AuditActions.SET:
      newState = removeAudit(state, action.payload._id);
      return addAudit(newState, action.payload);
    case AuditActions.ADD_ALL:
      return [...action.payload];
    default:
      return state;
  }
}

function addAudit(state: Array<AuditEntity>, audit: AuditEntity): Array<AuditEntity> {
  return [...state, audit];
}

function removeAudit(state: Array<AuditEntity>, id: string): Array<AuditEntity> {
  return state.filter((audit) => audit._id !== id);
}



// WEBPACK FOOTER //
// ./src/store/audit/audit.reducer.ts